import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import {
  getClinicalReport,
  getAccountInfo,
  getBuilds,
  getAccounts,
  getOrders,
  removeNotification,
  fetched as setInitialPayloadFetched,
} from '@store/actions';

import App, { AppStateProps, AppDispatchProps } from '../components/App';

interface IMapStateToProps
  extends Pick<
    IApplicationState,
    'authentication' | 'initialPayload' | 'notifications'
  > {}

const mapStateToProps = ({
  authentication,
  initialPayload,
  notifications,
}: IMapStateToProps): AppStateProps => ({
  authenticationStatus: authentication.status,
  accountId: authentication.user?.accountId,
  adaptiveSuperUser: authentication.user?.adaptiveSuperUser || false,
  initialPayloadFetched: initialPayload.fetched,
  notifications: notifications.notifications,
});

const mapDispatchToProps = (dispatch: any): AppDispatchProps => ({
  getOrders: () => dispatch(getOrders()),
  getAccounts: () => dispatch(getAccounts()),
  setInitialPayloadFetched: () => dispatch(setInitialPayloadFetched()),
  getBuilds: () => dispatch(getBuilds()),
  removeNotification: () => dispatch(removeNotification()),
  getAccountInfo: () => dispatch(getAccountInfo()),
  getClinicalReport: () => dispatch(getClinicalReport()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
